export const AuthStorage = {
  USER: '_au',
  USER_OLD: '_auo',
  ROLE: '_ar',
  ACCESS_TOKEN: '_at',
  REFRESH_TOKEN: '_rt',
  REFRESH_TOKEN_EXPIRATION: '_rtexp',
  TOKENIZED_LOGIN: '_tl',
  COGNITO_ACCESS_TOKEN: '_cat',
  COGNITO_REFRESH_TOKEN: '_crt',
  LOGOUT_INITIATED: '_logout',
  LAST_ACTIVITY: '_la',
} as const;
